import cardYellow from "../../assets/card-yellow.png";
import cardGreen from "../../assets/card-green.png";
import { useState } from "react";
import ToggleBar from "../app/Toggle";
import Modal from "../app/Modal";
import Card from "../app/Card";

interface Stops {
  value: string;
}
export interface OrderRideProps {
  nextDispatchOrderPage: () => void;
}
export default function OrderRide({ nextDispatchOrderPage }: OrderRideProps) {
  const [stops, setStops] = useState<Stops[]>([{ value: "" }]);
  const [scheduleModal, setScheduleModal] = useState<boolean>(false);
  const [rideTypeModal, setRideTypeModal] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [rideType, setRideType] = useState<string>("");
  const [schedule, setSchedule] = useState<{ date: string; time: string }>({
    date: "",
    time: "",
  });

  function showModal() {
    setScheduleModal(!scheduleModal);
  }
  function showRideModal() {
    setRideTypeModal(!rideTypeModal);
  }
  function handleToggleClick() {
    setToggle(!toggle);
  }

  function handleStopChange(
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const newStops: Stops[] = [...stops];
    newStops[index].value = event.target.value;
    setStops(newStops);
  }

  function handleAddStop() {
    setStops([...stops, { value: "" }]);
  }

  function handleRemoveStop(index: number) {
    const newFields = [...stops];
    newFields.splice(index, 1);
    setStops(newFields);
  }
  return (
    <div>
      <Card header="Order Ride">
        <div className="space-y-7 my-2">
          <div>
            <label htmlFor="email" className="secondary-text">
              Pickup Location
            </label>
            <div className="input-field">
              <input
                type="text"
                name="pickupLocation"
                required
                className="w-full"
              />
            </div>
          </div>

          {/* STOPS  */}
          <div>
            {stops.map((field, index) => (
              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="email" className="secondary-text">
                    Delivery Location
                  </label>
                  <div
                    onClick={() => handleRemoveStop(index)}
                    className="bg-accent w-2 h-2 flex items-center justify-center p-4 rounded-full hover:cursor-pointer"
                  >
                    <h1 className="font-medium">{index}</h1>
                  </div>
                </div>
                <div className="input-field">
                  <input
                    value={field.value}
                    onChange={(e) => handleStopChange(index, e)}
                    type="text"
                    name="deliveryLocation"
                    required
                    className="w-full"
                  />
                </div>
              </div>
            ))}
            <div className="relative w-full py-2 flex items-center justify-between mt-2">
              <h1
                className="text-primary absolute right-0 font-medium hover:cursor-pointer"
                onClick={handleAddStop}
              >
                Add Stop
              </h1>
            </div>
          </div>

          {/* SCHEDULE  */}
          <div>
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-primaryBlack font-medium">
                  Schedule Delivery
                </h1>
              </div>
              <div onClick={showModal}>
                <ToggleBar
                  toggleOn={toggle}
                  handleToggleClick={handleToggleClick}
                />
              </div>
            </div>
            <Modal
              openModal={scheduleModal}
              setOpenModal={showModal}
              header="Schedule delivery"
            >
              <div className="space-y-5">
                <div>
                  <label htmlFor="scheduleTime" className="secondary-text">
                    Time
                  </label>
                  <div className="input-field">
                    <input
                      value={schedule.time}
                      onChange={(e) =>
                        setSchedule({ ...schedule, time: e.target.value })
                      }
                      type="time"
                      name="scheduleTime"
                      required
                      className="w-full"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="scheduleDate" className="secondary-text">
                    Date
                  </label>
                  <div className="input-field">
                    <input
                      value={schedule.date}
                      onChange={(e) =>
                        setSchedule({ ...schedule, date: e.target.value })
                      }
                      type="date"
                      name="scheduleDate"
                      required
                      className="w-full"
                    />
                  </div>
                </div>
              </div>
              <div className="px-6" onClick={showModal}>
                <div className="absolute bottom-6 w-full px-6 left-0">
                  <button className="w-full bottom-6 font-medium">
                    Confirm
                  </button>
                </div>
              </div>
            </Modal>
            <div className="my-4 w-full">
              {schedule.date && schedule.time && (
                <div className="flex justify-between w-full">
                  <div>
                    <h1 className="font-medium text-paragraph">Date</h1>
                    <p className="text-secondary mt-1">{schedule?.date}</p>
                  </div>
                  <div className="flex items-center space-x-1">
                    <h1 className="font-medium text-paragraph">Time</h1>
                    <p className="text-secondary mt-1">{schedule?.time}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* RIDE TYPE  */}
          <Modal
            openModal={rideTypeModal}
            setOpenModal={showRideModal}
            header="Select Mode"
          >
            <div className="space-y-8">
              <div
                style={{
                  backgroundImage: `url('${cardYellow}')`,
                }}
                onClick={() => setRideType("express")}
                className={`bg-cover bg-center p-5 rounded-lg hover:cursor-pointer flex justify-between ${
                  rideType === "express" && "border border-themeYellow"
                }`}
              >
                <div>
                  <h1 className="font-semibold text-lg text-themeYellow">
                    Express
                  </h1>
                  <p className="font-medium text-paragraph mt-1">
                    Lorem ipsum dolor sit amet consectetur. Orci non suspendisse
                    eget et.
                  </p>
                </div>
                <div className="w-6 h-6 rounded-full">
                  <input
                    checked={rideType === "express" ? true : false}
                    onChange={() => setRideType("express")}
                    type="checkbox"
                    className="w-full bg-white checked:bg-primary"
                    id=""
                  />
                </div>
              </div>
              <div
                style={{
                  backgroundImage: `url('${cardGreen}')`,
                }}
                onClick={() => setRideType("normal")}
                className={`bg-cover bg-center p-5 rounded-lg hover:cursor-pointer flex justify-between ${
                  rideType === "normal" && "border border-[#27AD27]"
                }`}
              >
                <div>
                  <h1 className="font-semibold text-lg text-[#27AD27]">
                    Normal
                  </h1>
                  <p className="font-medium text-paragraph mt-1">
                    Lorem ipsum dolor sit amet consectetur. Orci non suspendisse
                    eget et.
                  </p>
                </div>
                <div className="w-6 h-6 rounded-full">
                  <input
                    checked={rideType === "normal" ? true : false}
                    onChange={() => setRideType("normal")}
                    type="checkbox"
                    className="w-full bg-white checked:bg-primary"
                    id=""
                  />
                </div>
              </div>
            </div>
            <div className="px-6">
              <div
                onClick={nextDispatchOrderPage}
                className="absolute bottom-6 w-full px-6 left-0"
              >
                <button className="w-full bottom-6 font-medium">Confirm</button>
              </div>
            </div>
          </Modal>

          <div className="bg-primary rounded-lg" onClick={showRideModal}>
            <button type="submit" className="w-full font-medium">
              Proceed
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
